import script from "./Team.vue?vue&type=script&setup=true&lang=js"
export * from "./Team.vue?vue&type=script&setup=true&lang=js"

import "./Team.vue?vue&type=style&index=0&id=69e1e07a&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e1e07a"]])

export default __exports__